import { TEAM_HEALTH_MONITOR_PAGE } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const teamHealthMonitorRoute = createSiteRoute({
  exact: true,
  name: TEAM_HEALTH_MONITOR_PAGE,
  path: '/team/health/:teamId/monitor/:teamHealthUuid?',
});
